import React from 'react';
import './OmSaiPGSection.css';
import { Link } from 'react-router-dom';

const OmSaiPG = () => {
  return (
    
    <div className="om-sai-pg-section">
      <div className="content-container">
        <h2 className="heading">Welcome to Om Sai PG</h2>
        <p className="description">
          Om Sai PG offers a unique and welcoming environment that aims to make
          residents feel at home. At Om Sai PG, we focus on providing comfortable
          and fully furnished living spaces for students, professionals, and anyone
          looking for short-term housing.
        </p>
        <div className="cta-buttons">
          <button className="cta-btn contact-us" ><i class="bi bi-whatsapp text-yellow"></i> <Link to='https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking a room at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!!' className='text-yellow fs-5' target="_blank">Enquiry Now</Link> </button>
          <button className="cta-btn contact-us" target="_blank"><Link to='tel:+919763888448' className='text-yellow'> <i class="bi bi-telephone-fill text-yellow fs-3"></i> Call Now</Link> </button>
        </div>
      </div>
    </div>
  );
};

export default OmSaiPG;
